import type { RouterOutputs } from '@package/api'
import { Button, toast } from '@ui/web/components'

interface DownloadPinProps {
  type: 'web' | 'school'
  data: RouterOutputs['myOrganization']['listChildren']['data']
}

export function DownloadPin({ type, data }: DownloadPinProps) {
  const convertToCSV = () => {
    if (type === 'web') {
      const headersWeb = ['Nama Anak', 'PIN']
      const rowsWeb = data.map((d) => [d.name, d.pin].join(','))

      return [headersWeb.join(','), ...rowsWeb].join('\n')
    }

    const headersSchool = ['Nama Murid', 'Kelas', 'PIN']
    const rowsSchool = data.map((d) =>
      [d.name, 'schoolClass' in d && d.schoolClass ? d.schoolClass.name : '-', d.pin].join(','),
    )

    return [headersSchool.join(','), ...rowsSchool].join('\n')
  }

  const downloadCSV = () => {
    if (data.length === 0) {
      toast.error('Tidak ada data untuk diunduh. Silahkan ganti filter data.')
      return
    }

    const csvContent = convertToCSV()
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `pin-${type === 'web' ? 'anak' : 'murid'}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <Button variant='outline' className='srd:w-fit srd:h-8 srd:px-4' onClick={downloadCSV}>
      Unduh PIN
    </Button>
  )
}
